"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  article: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    margin: theme.spacing(1),
    overflowY: "scroll",
    "& *": {
      boxSizing: "border-box"
    },
    backgroundColor: "white",
    fontFamily: "Akkurat, sans-serif",
    lineHeight: 1.5,
    "& h1": {
      fontSize: "1.5em",
      fontWeight: "bold",
      lineHeight: 1.25,
      margin: ".5em 0"
    },
    "& h2": {
      fontSize: "1.25em",
      fontWeight: "bold",
      lineHeight: 1.25,
      margin: ".5em 0"
    }
  }
}));

const ArticleBase = ({
  className,
  children
}) => {
  const classes = useStyles();
  return _react.default.createElement("article", {
    className: className || classes.article
  }, children);
};

var _default = ArticleBase;
exports.default = _default;
module.exports = exports.default;